// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1BM9A","inputWrap":"styles_inputWrap__2vish","input":"styles_input__23tis"};